export const EXTENDED_TEXT_LIST_SIZE = 30;
